// extracted by mini-css-extract-plugin
module.exports = {"container":"unavailable_container__MKf7s","title":"unavailable_title__XCaly","message":"unavailable_message__162_L","action":"unavailable_action__BfexS"};